// extracted by mini-css-extract-plugin
export default {"tableBox":"Table_tableBox__8s+NG","headerAll":"Table_headerAll__hQ8KR","sliderDiv":"Table_sliderDiv__nd7ZP","tableDiv":"Table_tableDiv__DgogZ","tableBody":"Table_tableBody__8xco1"};